import { number, object, setLocale, string } from 'yup'
import { useSelector } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { useStepsContext } from 'src/views/Requests/views/Form'
import { stringify } from 'src/core/hooks/use-translation'

import { Request, RequestItinerary } from 'src/types'

type ValidateProps = {
  request: Request
  values: RequestItinerary
}

function useGetInitialValues(): RequestItinerary {
  const { requests } = useSelector((state: ApplicationState) => ({
    requests: state.requests
  }))
  const stepsContext = useStepsContext()
  const requested_on =
    (stepsContext.request !== null
      ? stepsContext.request.requested_on
      : requests.fullRequest.requested_on) || moment().unix()

  const ended_on = moment
    .unix(requested_on)
    .utc()
    .set({ hour: 18, minute: 0, second: 0, millisecond: 0 })
    .unix()
  const started_on = moment
    .unix(requested_on)
    .utc()
    .set({ hour: 8, minute: 0, second: 0, millisecond: 0 })
    .unix()

  return (function () {
    return {
      active: true,
      activity: '',
      description: '',
      ended_on,
      latitude: '',
      longitude: '',
      reference_id: null,
      request_id: null,
      request_itinerary_id: null,
      request_itinerary_number: null,
      started_on,
      tmp_id: null
    } as RequestItinerary
  })()
}

function getValidationSchema() {
  setLocale({
    // use constant translation keys for messages without values
    mixed: {
      required: 'common.required',
      notType: 'common.required'
    }
  })

  return object().shape({
    reference_id: number().typeError().required(),
    activity: string()
      .trim()
      .max(
        250,
        stringify('web.setup.form.field-title.max-character-error', {
          value: 250
        })
      )
      .required(),
    latitude: string().trim().required(),
    longitude: string().trim().required(),
    description: string().trim().required(),
    started_on: number().required(),
    ended_on: number().required()
  })
}

function validate({ request, values }: ValidateProps): object {
  const errors: any = {}
  const todayTest = moment.unix(request.requested_on).format('YYYYMMDD')

  if (
    moment.unix(values.started_on).utc().format('YYYYMMDD') < todayTest ||
    moment.unix(values.ended_on).utc().format('YYYYMMDD') < todayTest
  )
    errors.started_on = stringify('web.itinerary.form.period.error-starter', {
      value: moment.unix(request.requested_on).format('DD MMMM YYYY')
    })
  return errors
}

export { useGetInitialValues, getValidationSchema, validate }
